module.exports = __webpack_public_path__ + "static/background.3ed9261d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.png
// module id = 459
// module chunks = 213534597649335